"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _PolygonizeDirectedEdge = _interopRequireDefault(require("./PolygonizeDirectedEdge"));

var _HashSet = _interopRequireDefault(require("../../../../../java/util/HashSet"));

var _Stack = _interopRequireDefault(require("../../../../../java/util/Stack"));

var _Node = _interopRequireDefault(require("../../planargraph/Node"));

var _PolygonizeEdge = _interopRequireDefault(require("./PolygonizeEdge"));

var _EdgeRing = _interopRequireDefault(require("./EdgeRing"));

var _CoordinateArrays = _interopRequireDefault(require("../../geom/CoordinateArrays"));

var _ArrayList = _interopRequireDefault(require("../../../../../java/util/ArrayList"));

var _Assert = _interopRequireDefault(require("../../util/Assert"));

var _PlanarGraph2 = _interopRequireDefault(require("../../planargraph/PlanarGraph"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var PolygonizeGraph =
/*#__PURE__*/
function (_PlanarGraph) {
  _inherits(PolygonizeGraph, _PlanarGraph);

  function PolygonizeGraph() {
    var _this;

    _classCallCheck(this, PolygonizeGraph);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(PolygonizeGraph).call(this));
    PolygonizeGraph.constructor_.apply(_assertThisInitialized(_this), arguments);
    return _this;
  }

  _createClass(PolygonizeGraph, [{
    key: "findEdgeRing",
    value: function findEdgeRing(startDE) {
      var er = new _EdgeRing.default(this._factory);
      er.build(startDE);
      return er;
    }
  }, {
    key: "computeDepthParity",
    value: function computeDepthParity() {
      if (arguments.length === 0) {
        while (true) {
          var de = null;
          if (de === null) return null;
          this.computeDepthParity(de);
        }
      } else if (arguments.length === 1) {
        var _de = arguments[0];
      }
    }
  }, {
    key: "computeNextCWEdges",
    value: function computeNextCWEdges() {
      for (var iNode = this.nodeIterator(); iNode.hasNext();) {
        var node = iNode.next();
        PolygonizeGraph.computeNextCWEdges(node);
      }
    }
  }, {
    key: "addEdge",
    value: function addEdge(line) {
      if (line.isEmpty()) {
        return null;
      }

      var linePts = _CoordinateArrays.default.removeRepeatedPoints(line.getCoordinates());

      if (linePts.length < 2) {
        return null;
      }

      var startPt = linePts[0];
      var endPt = linePts[linePts.length - 1];
      var nStart = this.getNode(startPt);
      var nEnd = this.getNode(endPt);
      var de0 = new _PolygonizeDirectedEdge.default(nStart, nEnd, linePts[1], true);
      var de1 = new _PolygonizeDirectedEdge.default(nEnd, nStart, linePts[linePts.length - 2], false);
      var edge = new _PolygonizeEdge.default(line);
      edge.setDirectedEdges(de0, de1);
      this.add(edge);
    }
  }, {
    key: "deleteCutEdges",
    value: function deleteCutEdges() {
      this.computeNextCWEdges();
      PolygonizeGraph.findLabeledEdgeRings(this._dirEdges);
      var cutLines = new _ArrayList.default();

      for (var i = this._dirEdges.iterator(); i.hasNext();) {
        var de = i.next();
        if (de.isMarked()) continue;
        var sym = de.getSym();

        if (de.getLabel() === sym.getLabel()) {
          de.setMarked(true);
          sym.setMarked(true);
          var e = de.getEdge();
          cutLines.add(e.getLine());
        }
      }

      return cutLines;
    }
  }, {
    key: "getEdgeRings",
    value: function getEdgeRings() {
      this.computeNextCWEdges();
      PolygonizeGraph.label(this._dirEdges, -1);
      var maximalRings = PolygonizeGraph.findLabeledEdgeRings(this._dirEdges);
      this.convertMaximalToMinimalEdgeRings(maximalRings);
      var edgeRingList = new _ArrayList.default();

      for (var i = this._dirEdges.iterator(); i.hasNext();) {
        var de = i.next();
        if (de.isMarked()) continue;
        if (de.isInRing()) continue;
        var er = this.findEdgeRing(de);
        edgeRingList.add(er);
      }

      return edgeRingList;
    }
  }, {
    key: "getNode",
    value: function getNode(pt) {
      var node = this.findNode(pt);

      if (node === null) {
        node = new _Node.default(pt);
        this.add(node);
      }

      return node;
    }
  }, {
    key: "convertMaximalToMinimalEdgeRings",
    value: function convertMaximalToMinimalEdgeRings(ringEdges) {
      for (var i = ringEdges.iterator(); i.hasNext();) {
        var de = i.next();
        var label = de.getLabel();
        var intNodes = PolygonizeGraph.findIntersectionNodes(de, label);
        if (intNodes === null) continue;

        for (var iNode = intNodes.iterator(); iNode.hasNext();) {
          var node = iNode.next();
          PolygonizeGraph.computeNextCCWEdges(node, label);
        }
      }
    }
  }, {
    key: "deleteDangles",
    value: function deleteDangles() {
      var nodesToRemove = this.findNodesOfDegree(1);
      var dangleLines = new _HashSet.default();
      var nodeStack = new _Stack.default();

      for (var i = nodesToRemove.iterator(); i.hasNext();) {
        nodeStack.push(i.next());
      }

      while (!nodeStack.isEmpty()) {
        var node = nodeStack.pop();
        PolygonizeGraph.deleteAllEdges(node);
        var nodeOutEdges = node.getOutEdges().getEdges();

        for (var i = nodeOutEdges.iterator(); i.hasNext();) {
          var de = i.next();
          de.setMarked(true);
          var sym = de.getSym();
          if (sym !== null) sym.setMarked(true);
          var e = de.getEdge();
          dangleLines.add(e.getLine());
          var toNode = de.getToNode();
          if (PolygonizeGraph.getDegreeNonDeleted(toNode) === 1) nodeStack.push(toNode);
        }
      }

      return dangleLines;
    }
  }, {
    key: "getClass",
    value: function getClass() {
      return PolygonizeGraph;
    }
  }, {
    key: "interfaces_",
    get: function get() {
      return [];
    }
  }], [{
    key: "findLabeledEdgeRings",
    value: function findLabeledEdgeRings(dirEdges) {
      var edgeRingStarts = new _ArrayList.default();
      var currLabel = 1;

      for (var i = dirEdges.iterator(); i.hasNext();) {
        var de = i.next();
        if (de.isMarked()) continue;
        if (de.getLabel() >= 0) continue;
        edgeRingStarts.add(de);

        var edges = _EdgeRing.default.findDirEdgesInRing(de);

        PolygonizeGraph.label(edges, currLabel);
        currLabel++;
      }

      return edgeRingStarts;
    }
  }, {
    key: "getDegreeNonDeleted",
    value: function getDegreeNonDeleted(node) {
      var edges = node.getOutEdges().getEdges();
      var degree = 0;

      for (var i = edges.iterator(); i.hasNext();) {
        var de = i.next();
        if (!de.isMarked()) degree++;
      }

      return degree;
    }
  }, {
    key: "deleteAllEdges",
    value: function deleteAllEdges(node) {
      var edges = node.getOutEdges().getEdges();

      for (var i = edges.iterator(); i.hasNext();) {
        var de = i.next();
        de.setMarked(true);
        var sym = de.getSym();
        if (sym !== null) sym.setMarked(true);
      }
    }
  }, {
    key: "label",
    value: function label(dirEdges, _label) {
      for (var i = dirEdges.iterator(); i.hasNext();) {
        var de = i.next();
        de.setLabel(_label);
      }
    }
  }, {
    key: "computeNextCWEdges",
    value: function computeNextCWEdges(node) {
      var deStar = node.getOutEdges();
      var startDE = null;
      var prevDE = null;

      for (var i = deStar.getEdges().iterator(); i.hasNext();) {
        var outDE = i.next();
        if (outDE.isMarked()) continue;
        if (startDE === null) startDE = outDE;

        if (prevDE !== null) {
          var sym = prevDE.getSym();
          sym.setNext(outDE);
        }

        prevDE = outDE;
      }

      if (prevDE !== null) {
        var sym = prevDE.getSym();
        sym.setNext(startDE);
      }
    }
  }, {
    key: "computeNextCCWEdges",
    value: function computeNextCCWEdges(node, label) {
      var deStar = node.getOutEdges();
      var firstOutDE = null;
      var prevInDE = null;
      var edges = deStar.getEdges();

      for (var i = edges.size() - 1; i >= 0; i--) {
        var de = edges.get(i);
        var sym = de.getSym();
        var outDE = null;
        if (de.getLabel() === label) outDE = de;
        var inDE = null;
        if (sym.getLabel() === label) inDE = sym;
        if (outDE === null && inDE === null) continue;

        if (inDE !== null) {
          prevInDE = inDE;
        }

        if (outDE !== null) {
          if (prevInDE !== null) {
            prevInDE.setNext(outDE);
            prevInDE = null;
          }

          if (firstOutDE === null) firstOutDE = outDE;
        }
      }

      if (prevInDE !== null) {
        _Assert.default.isTrue(firstOutDE !== null);

        prevInDE.setNext(firstOutDE);
      }
    }
  }, {
    key: "getDegree",
    value: function getDegree(node, label) {
      var edges = node.getOutEdges().getEdges();
      var degree = 0;

      for (var i = edges.iterator(); i.hasNext();) {
        var de = i.next();
        if (de.getLabel() === label) degree++;
      }

      return degree;
    }
  }, {
    key: "findIntersectionNodes",
    value: function findIntersectionNodes(startDE, label) {
      var de = startDE;
      var intNodes = null;

      do {
        var node = de.getFromNode();

        if (PolygonizeGraph.getDegree(node, label) > 1) {
          if (intNodes === null) intNodes = new _ArrayList.default();
          intNodes.add(node);
        }

        de = de.getNext();

        _Assert.default.isTrue(de !== null, "found null DE in ring");

        _Assert.default.isTrue(de === startDE || !de.isInRing(), "found DE already in ring");
      } while (de !== startDE);

      return intNodes;
    }
  }]);

  return PolygonizeGraph;
}(_PlanarGraph2.default);

exports.default = PolygonizeGraph;

PolygonizeGraph.constructor_ = function () {
  this._factory = null;
  var factory = arguments[0];
  this._factory = factory;
};